import { render, staticRenderFns } from "./proofCategoryForm.vue?vue&type=template&id=0a91ba6a"
import script from "./proofCategoryForm.vue?vue&type=script&lang=js"
export * from "./proofCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports